import React, { ReactNode } from 'react';
import { Column, Square } from '@grubhubprod/gh-cookbook-react';
import { ColumnOptions } from 'src/components/EnterpriseSetupTable/EnterpriseSetupTable';

interface TieredAccountCellProps {
  children: ReactNode;
  width: ColumnOptions;
}

export const TieredAccountCell: React.FC<TieredAccountCellProps> = ({
  children,
  width,
}) => {
  return (
    <Column desktop={width}>
      <Square inset="md" alignItems="center" className="ellipsisOverflow">
        {children}
      </Square>
    </Column>
  );
};
